import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import { localizePath } from '../utils/localePaths';

export function LocalizedLink({ to, ...rest }) {
  const { localePrefix } = useLocale();
  const localizedTo = typeof to === 'string' ? localizePath(to, localePrefix) : to;
  return <Link to={localizedTo} {...rest} />;
}
